// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1hqZ1","question":"Question_question__l21D7","description":"Question_description__uJeb7"};